import PropTypes from "prop-types";
import Button from "../Button";
import classnames from "classnames";

const RetryButton = ({ action, className }) => (
  <Button
    action={action}
    contentKey={"saved_items_pageload_error_retry"}
    className={classnames(className)}
  />
);

RetryButton.propTypes = {
  action: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default RetryButton;
